import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-190469ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center justify-center" }
const _hoisted_2 = { class: "rating" }
const _hoisted_3 = ["onClick", "onMouseover"]
const _hoisted_4 = {
  key: 0,
  class: "error-message"
}

import { Field, useField } from 'vee-validate';
import { ref } from 'vue';


export default {
  __name: 'RatingField',
  setup(__props) {

const { errorMessage, setValue } = useField('rating');

const rating = ref(0);
const hoverRating = ref(0);
const stars = ref([1, 2, 3, 4, 5]);

const setRating = (star) => {
    rating.value = star;
    setValue(star);
};

const setHover = (star) => {
    hoverRating.value = star;
};

const clearHover = (star) => {
    hoverRating.value = star;
};

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Field), {
      name: "rating",
      type: "hidden"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stars.value, (star) => {
          return (_openBlock(), _createElementBlock("span", {
            key: star,
            class: _normalizeClass(["star", { active: star <= (rating.value || hoverRating.value) }]),
            onClick: $event => (setRating(star)),
            onMouseover: $event => (setHover(star)),
            onMouseleave: clearHover
          }, " ★ ", 42, _hoisted_3))
        }), 128))
      ])
    ]),
    (_unref(errorMessage))
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(errorMessage)), 1))
      : _createCommentVNode("", true)
  ]))
}
}

}